import PropTypes from 'prop-types';
import React from 'react';
import StyledRadioButton from './radioButton.style';
import RadioButtonShape from '../../icons/radioButtonShape.svg';

const RadioButton = React.forwardRef(
  (
    {
      label,
      name,
      onFocus,
      onBlur,
      onChange,
      error = false,
      disabled = false,
      active,
      checked = false,
      color
    },
    ref
  ) => (
    <StyledRadioButton disabled={disabled} error={error} active={active} color={color}>
      <label htmlFor={label} className="radioButton__wrapper" ref={ref}>
        <input
          id={label}
          name={name}
          type="radio"
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={onChange}
          disabled={disabled}
          checked={checked}
        />
        <span className="radioButton__custom-radio">
          <RadioButtonShape className="radioButton__shape" />
          <span className="radioButton__check" />
        </span>
        <span className="radioButton__label">{label}</span>
      </label>
    </StyledRadioButton>
  )
);

RadioButton.displayName = 'RadioButton';

RadioButton.propTypes = {
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  active: PropTypes.bool,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  color: PropTypes.string
};

export default RadioButton;
